<template>
    <form @submit.prevent="submit()" :enctype="enctype" :method="method == 'PATCH' || method == 'DELETE' ? 'POST' : method" :action="action">
        <slot></slot>
        <input type="hidden" name="_token" :value="csrf" />
        <input name="_method" type="hidden" v-if="method == 'PATCH'" value="PATCH">
        <input name="_method" type="hidden" v-if="method == 'DELETE'" value="DELETE">
        <div class="form-footer" v-if="button != ''">
            <button v-bind:class="submitButton" class="loader-btn" type="submit">
                <div class="loader small white"></div>
                <div class="msg">{{ buttonText }}</div>
            </button>
        </div>
    </form>
</template>

<script>
    module.exports = {
        created: function () {
            if(this.buttonClass != undefined) {
                var classes = this.buttonClass.split(' ');
                var form = this;
                if(classes.length > 0) {
                    $.each(classes,function(index,value) {
                        form.submitButton[value] = true;
                    });
                }
            }
            if(this.button != undefined) {
                this.buttonText = this.button;
            }
        },
        data:function() {
            return {
                attempts:0,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                isSubmitting:false,
                loaderTimeout:false,
                buttonText:"Submit",
                submitButton: {
                    button:true,
                    isLoading:false,
                    block:false,
                    lime:false,
                    red:false,
                    yellow:false
                }
            }
        },
        props: {
            method:{ type:String, default:"POST" },
            action:{ type:String, default: "" },
            button: { type: String, default: "" },
            enctype: { type: String, default: "" },
            enableSubmit: { type:Boolean, default:true }
        },
        methods: {
            hasErrors:function() {
                var e = this.$el;
                var hasErrors = false;
                $(e).find('input,select,textarea').each(function() {
                    if($(this).hasClass('required') && !$(this).is(':disabled') && $(this).is(':visible')) {
                        if($(this).val() == '') {
                            $(this).addClass('error');
                            hasErrors = true;
                        } else {
                            $(this).removeClass('error');
                        }
                    }
                });
                return hasErrors;
            },
            submit:function() {
                if(this.button != "" || this.enableSubmit) {
                    this.attempts += 1;
                    if (this.isSubmitting) {
                        return false;
                    }
                    if (!this.hasErrors()) {
                        this.submitButton.isLoading = true;
                        this.isSubmitting = true;
                        var e = this.$el;
                        var method = $(e).attr('method');
                        var action = $(e).attr('action');
                        var data = $(e).serializeArray();
                        if(this.enableSubmit) {
                            $(e).find('.loader-btn').addClass('isLoading');
                        }
                        var formData = {};
                        var form = this;
                        if (data && data.length > 0) {
                            $.each(data, function (index, value) {
                                var name = value.name;
                                if(name.slice(-2) == '[]') {
                                    name = value.name.slice(0,-2);
                                    if(formData[name] == undefined) {
                                        formData[name] = [];
                                    }
                                    formData[name].push(value.value);
                                } else {
                                    formData[name] = value.value;
                                }
                            });
                        }
                        //console.log(formData);
                        $.ajax({
                            url: action,
                            type: method,
                            data: formData,
                            success: function (data) {
                                form.submitButton.isLoading = false;
                                form.response(data);
                                if(form.enableSubmit) {
                                    $(e).find('.loader-btn').removeClass('isLoading');
                                }
                            },
                            error: function (data) {
                                form.submitButton.isLoading = false;
                                form.isSubmitting = false;
                                if(form.enableSubmit) {
                                    $(e).find('.loader-btn').removeClass('isLoading');
                                }
                                if (data != undefined && data.responseJSON != undefined && data.responseJSON.message != undefined) {
                                    if (data.status == 419 && data.responseJSON.message == 'CSRF token mismatch.' && form.attempts < 2) {
                                        form.flashMessage("419 - CSRF token mismatch.", 'red');
                                    } else {
                                        var message = false;
                                        if(data.responseJSON.errors != undefined) {
                                            $.each(data.responseJSON.errors,function(_,value) {
                                                if(!message) {
                                                    if (value.length > 0) {
                                                        message = value[0];
                                                    }
                                                }
                                            });
                                        }
                                        if(!message) {
                                            message = data.status + " - " + data.responseJSON.message;
                                        }
                                        form.flashMessage(message, 'red');
                                    }
                                } else {
                                    form.flashMessage("Oops! An error occured.", 'red');
                                }
                            }
                        });
                    }
                } else {
                    if(!this.hasErrors()) {
                        var e = this.$el;
                        $(e).submit();
                    }
                }
            },
            response:function(data) {
                if(data.status != undefined && data.status == 200) {
                    if(data.data != undefined) {
                        data = data.data;
                        if(data.callback) {
                            eval(data.callback);
                        }
                        if(data.project != undefined) {
                            this.$updateProject(data.project);
                        } else if(data.projectData != undefined) {
                            this.$updateProjectData(data.projectData);
                        }
                        if(data.refresh != undefined){
                             this.$refresh();
                        }
                        if(data.reload != undefined) {
                            document.location.href = document.location.href;
                        } else if(data.redirect != undefined) {
                            document.location.href = data.redirect;
                        } else if(data.location != undefined) {
                            document.location.href = data.location;
                        }
                        if(data.drawer != undefined && data.drawer != '') {
                            this.$openDrawer(data.drawer);
                        }
                        if(data.refreshBottomDrawer != undefined) {
                            this.$refreshBottomDrawer();
                        }
                        if(data.modal != undefined && data.modal != '') {
                            this.$openModal(data.modal);
                        } else {
                            setTimeout(function() {
                                this.$closeModal();
                            }.bind(this),2000);
                        }
                    }
                    this.flashMessage(data.msg,'lime');
                    var form = this;
                    if(form.$root.modal != undefined && form.$root.modal.isOpen) {
                        setTimeout(function() {
                            form.$root.modal.close();
                        },1000);
                    }
                } else {
                    this.error(data);
                }
            },
            error:function(data) {
                if(data.status != undefined && data.status == 204) {
                    // LOGGED OUT
                    this.flashMessage("Oops! You are not logged in.",'red');
                } else {
                    // General error
                    if(data.msg != undefined) {
                        this.flashMessage(data.msg,'red');
                    } else {
                        this.flashMessage("Oops! An error occured.",'red');
                    }
                }
            },
            flashMessage:function(message,color,timing = 2000) {
                var form = this;

                if(message != undefined) {
                    var holdMessage = form.buttonText;
                    form.buttonText = message;
                    if(form.enableSubmit) {
                        holdMessage = $(form.$el).find('.loader-btn .msg').html();
                        $(form.$el).find('.loader-btn .msg').html(message);
                    }
                    setTimeout(function () {
                        form.buttonText = holdMessage;
                        if(form.enableSubmit) {
                            $(form.$el).find('.loader-btn .msg').html(holdMessage);
                        }
                    }, timing);
                }

                if(color != undefined) {
                    var flash = form.submitButton[color] ? false : true;
                    form.submitButton[color] = true;
                    if(form.enableSubmit) {
                        $(form.$el).find('.loader-btn').addClass(color);
                    }
                    if (flash) {
                        setTimeout(function () {
                            form.submitButton[color] = false;
                            if(form.enableSubmit) {
                                $(form.$el).find('.loader-btn').removeClass(color);
                            }
                        }, timing)
                    }
                }

                setTimeout(function() {
                    form.isSubmitting = false;
                },timing);
            }
        }
    }
</script>
